import { CanActivateFn, UrlTree } from '@angular/router';
import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from '../panelclient/services/user.service';
import { firstValueFrom } from 'rxjs';


//Mapeamento das rotas sempre preencher com novos modulos
const routesMap: Record<string, string[]> = {
      basicoMenu: ['app', 'disparos'],
      agendaMenu: ['app', 'agendas'],
      ekuroMenu: ['app', 'ecuro'],
      clinicorpMenu: ['app', 'clinicorp-menu'],
};

function getMenuKeys(obj: Record<string, any>) {
  // Filtra as entradas (pares [chave, valor])
  return Object.entries(obj)
    // mantém apenas as que terminam com 'Menu'
    .filter(([key]) => key.endsWith('Menu'))
    // transforma novamente em objeto { chave: valor }
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {} as Record<string, any>);
}

export const randomRouteGuard: CanActivateFn = async(route, state): Promise<boolean | UrlTree> => {
  
  const userService = inject(UserService);
  const router = inject(Router);
  const userConfig = await firstValueFrom(userService.getConfigUser());

  const permissions = getMenuKeys(userConfig.configUser);
  
  // Busca a primeira chave com valor true
  const activeMenu = Object.entries(permissions).find(
      ([key, value]) => key.endsWith('Menu') && value === true
    );

  if (activeMenu) {
      const [menuKey] = activeMenu;
      const path = routesMap[menuKey];

      if (path) return router.createUrlTree(path);
    }

  // Retorna o UrlTree (cancela a navegação atual e redireciona)
  return router.createUrlTree(['app', 'perfil']);
};
